import { EventStatus } from '@/interfaces/entities/event';

export const eventStatusColor = (status: EventStatus) => {
	switch (status) {
		case EventStatus.APPROVED:
			return 'text-green-500';
		case EventStatus.REJECTED:
			return 'text-red-500';
		case EventStatus.PENDING:
			return 'text-yellow-500';
	}
};
